import styled from 'styled-components';

import { spacing } from '@sine/sine-ui-components';

interface ContainerProps {
  flex?: boolean;
  fullWidth?: boolean;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  margin: 0 auto;
  padding: 0 ${spacing(2)};
  ${({ flex }) => (flex ? `display: flex; align-items: center;` : '')}

  &:before,
  &:after {
    content: ' ';
    display: table;
  }

  &:after {
    clear: both;
  }

  ${({ fullWidth }) =>
    fullWidth
      ? 'width: 100%'
      : `
    
    @media (min-width: 845px) {
      width: 750px;
    }
  
    @media (min-width: 992px) {
      width: 890px;
    }
  
    @media (min-width: 1025px) {
      width: 750px;
    }
  
    @media (min-width: 1180px) {
      width: 890px;
    }
  
    @media (min-width: 1411px) {
      width: 1170px;
    }
  
    @media (max-width: 481px) {
      max-width: 95vw;
    }
  `}
`;

export default Container;
